module.exports = __webpack_public_path__ + "img/4.6f8b1772.png";